<template>
  <div>
    <div style="width: 100%; height: 10px"></div>
    <div class="headInfo">
      <div @click="back">{{ backa }}返回</div>
      <div style="font-size: 15px; color: #882784" @click="backHome">首页</div>
      <div style="flex-grow: 2">我的发布</div>
      <div
        style="color: #882784; font-weight: bold; flex-grow: 2; font-size: 15px"
        @click="concath"
      >
        联系客服
      </div>
    </div>
    <!--温馨提示-->
    <div class="payMoney">
      <div class="icp_info" v-html="topHtml">
      </div>
    </div>
    <!-- 历史信息 -->
    <div class="history">
      <van-list
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="onLoad"
      >
        <HeadItemThree
          style="margin-top: 8px"
          @showTipsTC="showTipsTC"
          @ReGetInfo="ReGetInfo"
          v-for="(item, index) in articleList"
          :downInfo="(operateType=='goDownInfo'&&item.id==operateId)?true:false"
          :refreshInfo="(operateType=='goRefresh'&&item.id==operateId)?true:false"
          :key="index"
          :mes="item"
        ></HeadItemThree>
      </van-list>
    </div>
    <div
      :style="
        'width:100%;height:' +
        screenHeight +
        'px;background-color:#E7E7E7;position:fixed;left:0;top:0;z-index:-1;'
      "
    ></div>
    <!--提示弹窗-->
    <van-popup v-model="showTips" class="tipsTC">
      <div class="showTips">
        <div class="closeTc">
          <img
            src="../assets/images/images/closeTC.png"
            alt=""
            @click="closePayTc"
          />
        </div>
        <!--tips-->
        <div class="tips">
          <div class="tipsTop">
            <img src="../assets/images/images/successInfo.png" alt="" />
            开通包周VIP刷新服务，增加曝光，加速成交！
          </div>
          <div class="tipsMiddle">
            此服务共含{{mounthNum}}次VIP刷新权限，信息刷新后能再次靠前显示，可在“我的发布”里操作！
          </div>
          <div class="tipsBottom">
            （注：每天最多刷新{{ dataNum }}次，7天内使用完）
          </div>
        </div>
        <div class="selectPrice">
          <div>
            <img
              v-if="hasSelect"
              src="../assets/images/images/select.png"
              alt=""
              @click="changeSelectStatus"
            />
            <img
              v-else
              src="../assets/images/images/closeSelect.png"
              alt=""
              @click="changeSelectStatus"
            />
          </div>
          <div class="priceSec">
            <span>VIP刷新价</span
            ><span>{{ moneyInfo.fee / 100 }}元/周</span>
          </div>
        </div>
        <!--确认支付-->
        <div class="prePay">
          <div v-if="hasSelect" class="submitPay" @click="prePayMoney">
            确认支付
          </div>
          <div v-else class="submitPay noSelect">确认支付</div>
        </div>
      </div>
    </van-popup>
    <BackTop></BackTop>
  </div>
</template>
<script>
let me;
import axios from "axios";
import { ImagePreview } from "vant";
import { getData } from "../Interface/http.js";
import { postData } from "../Interface/http.js";
import HeadItemThree from "../components/HeadItemThree";
import BackTop from "../components/BackTop";
export default {
  name: "myPushMsg",
  data() {
    return {
      images: [],
      backa: "<<",
      loading: false,
      finished: false,
      articleList: [],
      screenHeight: "",
      page: 1,

      showTips: false,
      hasSelect: true,
      vipStatus: {}, //当前用户是否已开通vip，0：未开通，1：已开通
      dataNum: 0, //每天刷新的次数
      mounthNum: 0, //每月刷新的次数
      dayLimit: 0, //每天刷新次数限制
      mounthLimit: 0, //每月刷新次数限制
      moneyInfo: {}, //付款信息
      operateType: "", //操作类型
      operateId: "",//操作的贴子id
      topHtml: ''
    };
  },
  components: {
    HeadItemThree,
    BackTop,
  },
  methods: {
    getTopInfo() {
      getData('/article/search?title=我的发布顶部').then(res => {
        if(res.code == 0) {
          this.topHtml = res.data.content;
        }
      })
    },
    //处理信息队列列表
    dealNewsOptions() {
      let params = this.$route.query;
      if(params.id) {
        this.operateId = params.id;
      }
      if (params.type) {
        this.operateType = params.type;
        if (params.type == "goTop") {
          //置顶打开联系客服二维码
          me.concath();
        }
      }
    },
    backHome() {
      me.$router.push({
        name: "home",
      });
    },
    //确认支付
    prePayMoney() {
      postData("/payment/order/create", {
        trade_type: "mp",
        plan_id: me.moneyInfo.id,
      })
        .then((res) => {
          me.onBridgeReady(res.data);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //调起微信支付
    onBridgeReady(msg) {
      WeixinJSBridge.invoke("getBrandWCPayRequest", msg, function (res) {
        if (res.err_msg == "get_brand_wcpay_request:ok") {
          // 使用以上方式判断前端返回,微信团队郑重提示：
          //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
          me.closePayTc();
        }
      });
    },
    //关闭弹窗
    closePayTc() {
      this.showTips = false;
    },
    showTipsTC() {
      me.showTips = true;
    },
    //改变勾选状态
    changeSelectStatus() {
      me.hasSelect = !me.hasSelect;
    },
    //获取每日和每月刷新数
    getDayAndMounthCount() {
      getData("/vip/refresh-num")
        .then((res) => {
          if (res.code == "0") {
            me.dataNum = res.data.day_refresh_num; //每日数量
            me.mounthNum = res.data.month_refresh_num; //每月数量
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取VIP刷新体验价格
    getVipPrice() {
      getData("/vip/user-ob")
        .then((res) => {
          me.moneyInfo = res.data[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    selectKFImg() {
      //获取广告图片
      let me = this;
      getData("/recommend-lists?position=7")
        .then((res) => {
          if (res.code == 0) {
            var arr = [];
            arr = res.data.map((item) => {
              return item.banner.thumb_url;
            });
            me.images.push(...arr);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //联系客服
    concath() {
      ImagePreview(this.images);
    },
    back() {
      this.$router.go(-1);
    },
    ReGetInfo() {
      me.operateType = "";
      me.operateId = "";
      me.page = 1;
      me.finished = true;
      this.articleList = [];
      me.onLoad();
    },
    onLoad() {
      getData(
        "/user/messages",
        {
          page: me.page,
        },
        {
          headers: {
            token: localStorage.getItem("token"),
          },
        }
      ).then((res) => {
        this.loading = false;
        me.page = me.page + 1;
        if (res.data.length != 0) {
          res.data.map((a) => {
            this.articleList.push(a);
          });
          this.finished = false;
        } else {
          this.finished = true;
        }
      }).catch(errr=> {
        this.finished = true;
      });
    },
    hasReadInfo() {
      postData('/user/read-notify',{
        type_id: 2
      }).then(res => {
        console.log(res);
      })
    }
  },
  mounted() {
    me = this;
    me.screenHeight = window.screen.availHeight;
    me.selectKFImg();
    me.getVipPrice();
    me.getDayAndMounthCount();
    me.dealNewsOptions();
    me.hasReadInfo();
    me.getTopInfo();
    //me.onLoad();
  },
};
</script>
<style scoped>
.headInfo {
  width: 96%;
  height: 39.5px;
  margin-left: 2%;
  background-color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  color: #000;
}
.headInfo div {
  flex-grow: 1;
  flex-basis: 0;
}
.headInfo div:nth-child(1) {
  font-size: 15px;
  color: gray;
}
.history {
  padding: 10px 10px 5px;
  box-sizing: border-box;
}
.tipsTC {
  border-radius: 5px;
}
.showTips {
  width: 320px;
  height: fit-content;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}

.payMoney {
  width: 100%;
}
.payMoney div {
  margin: 0px 5px;
  background-color: #d9cbd8;
  border-radius: 5px;
  height: fit-content;
  font-size: 13px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 5px;
  color: #882784;
  margin-top: 10px;
  font-weight: bold;
}

/**支付预弹窗 */
.tips {
  background-color: #e7d4e6;
  margin: 0px 10px 10px 10px;
  border-radius: 5px;
  padding: 5px 5px;
}
.tipsTop {
  font-size: 13px;
  display: flex;
  align-items: center;
  font-weight: bold;
  color: #882784;
}
.tipsTop img {
  width: 20px;
  height: 20px;
}
.tipsMiddle {
  font-size: 13px;
  margin-top: 5px;
  text-align: left;
  color: #696969;
}
.tipsBottom {
  text-align: left;
  font-size: 13px;
  color: #696969;
}
.selectPrice {
  display: flex;
  justify-content: center;
  align-items: center;
}
.selectPrice > div:nth-child(1) {
  margin-right: 10px;
  display: flex;
  align-items: center;
}
.selectPrice img {
  width: 20px;
  height: 20px;
}
.priceSec {
  font-weight: bold;
  color: #882784;
  font-size: 20px;
}
.priceSec > span:nth-child(2) {
  font-weight: bolder;
  font-size: 23px;
}
.submitPay {
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 5px 110px;
  border-radius: 5px;
  background-color: #882784;
  height: 30px;
  color: #fff;
}
.noSelect {
  background-color: #cbcbcb;
}
.prePay {
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-bottom: 10px;
}
.closeTc {
  text-align: right;
}
.closeTc img {
  width: 25px;
  height: 25px;
  margin-top: 5px;
  margin-right: 5px;
}
.tipsTC {
  border-radius: 5px;
}
.showTips {
  width: 320px;
  height: fit-content;
  background-color: #fff;
  position: relative;
  overflow: hidden;
}
.radiusStyle {
  border-radius: 5px;
}
</style>